import { createStitches } from '@stitches/react';

var _createStitches = createStitches(),
    keyframes = _createStitches.keyframes,
    styled = _createStitches.styled;

export { keyframes, styled };